export default __webpack_public_path__ + "static/media/User_2.3a705ff4.svg";